/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DistributionChannelListItem
 */
export interface DistributionChannelListItem {
    /**
     * 
     * @type {number}
     * @memberof DistributionChannelListItem
     */
    id?: number;
    /**
     * 
     * @type {object}
     * @memberof DistributionChannelListItem
     */
    effectiveFrom?: object | null;
    /**
     * 
     * @type {object}
     * @memberof DistributionChannelListItem
     */
    effectiveTo?: object | null;
    /**
     * 
     * @type {string}
     * @memberof DistributionChannelListItem
     */
    label?: string | null;
}

export function DistributionChannelListItemFromJSON(json: any): DistributionChannelListItem {
    return DistributionChannelListItemFromJSONTyped(json, false);
}

export function DistributionChannelListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DistributionChannelListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'effectiveFrom': !exists(json, 'effectiveFrom') ? undefined : json['effectiveFrom'],
        'effectiveTo': !exists(json, 'effectiveTo') ? undefined : json['effectiveTo'],
        'label': !exists(json, 'label') ? undefined : json['label'],
    };
}

export function DistributionChannelListItemToJSON(value?: DistributionChannelListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'effectiveFrom': value.effectiveFrom,
        'effectiveTo': value.effectiveTo,
        'label': value.label,
    };
}


